import { useQuery } from '@tanstack/react-query'
import * as R from 'remeda'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'
import { applyIfExist, filterExists } from '~/utils'

import { useCommonQueryKey } from './useCommonQueryKey'

const document = graphql(`
  query UseCommonQuery_Main {
    me {
      id
      isCoreMember
      brandAccountRoles {
        brandAccount {
          id
          name
        }
        role {
          id
          name
        }
      }
      brandAccounts {
        id
        name
        isSurveyEditor
      }
    }
  }
`)

export const useCommonQuery = () => {
  const queryKey = useCommonQueryKey()
  const graphQLRequest = useGraphQLRequest()

  return useQuery({
    queryFn: async () => {
      const result = await graphQLRequest({ document })

      return R.pipe(
        result.me,
        applyIfExist((me) => ({
          ...me,
          brandAccountRoles: R.pipe(me.brandAccountRoles, filterExists),
          brandAccounts: R.pipe(
            me.brandAccounts,
            filterExists,
            R.map((brandAccount) => ({
              ...brandAccount,
              isSurveyEditor:
                brandAccount.isSurveyEditor === true ||
                me.isCoreMember === true,
            })),
          ),
        })),
      )
    },
    queryKey,
  })
}

export type Me = NonNullable<QueryResultOf<typeof useCommonQuery>>
export type BrandAccount = Me['brandAccounts'][number]
